import { UserSubmission } from "./UserSubmission";
import { Form } from "models/forms/Form";
import type { UserSubmissionDto } from "./UserSubmissionDto";

export class FormSubmission extends UserSubmission {
    formId: string = "";
    form: Form | null = null;
    type: string = "FormSubmission";
};

export interface FormSubmissionDto extends UserSubmissionDto {
    formId: string;
    formSubmission: FormSubmission;
}